module.exports = __webpack_public_path__ + "img/Image_logo_6.6bd8906c.jpg";